// extracted by mini-css-extract-plugin
module.exports = {"ds-banner-alert":"BannerAlert_ds-banner-alert__0PgyW","ds-banner-alert__text":"BannerAlert_ds-banner-alert__text__2EypZ","display-none":"BannerAlert_display-none__Ppk0y"};